import React, { useEffect, useState } from "react";
import { Box, Typography, Button, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import Drawer from "@mui/material/Drawer";
import { put, post, get } from "../../../../utils/api";
import InputField from "../../../../Components/Masters/InputField";
import SelectField from "../../../../Components/Masters/SelectField";
import FileField from "../../../../Components/Masters/FileField";
import { validateNumber } from "../../../../utils/validateFields";
import { numberError } from "../../../../utils/validationMessage";
import Multiline from "../../../../Components/Masters/Multiline";
import MonthYearPicker from "../../../../Components/Common/MonthYearPicker";
import EditDialog from "../../../../Components/Common/EditDialog";
import formatTitleWithOptional from "../../../Scope1/OptionalFeild";
import { useUser } from "../../../../context/AuthContext";

function AddConsumptionEquipment({
  inputData,
  fetchData,
  id,
  title,
  data,
  setAddData,
  addData,
  setsnackOpen,
  addUrl,
  updateUrl,
}) {
  const { user } = useUser();

  const [errors, setErrors] = useState({});
  const initialState = {
    consumptionPeriod: {
      month: data?.consumptionPeriod?.month || "",
      year: data?.consumptionPeriod?.year || "",
    },
    equipment: data?.equipment?._id || "",
    // equipment: data && data.equipment ? data.equipment._id : "",
    brand: data?.brand || "",
    model: data?.model || "",
    usedHours: data?.usedHours || "",
    remarks: data?.remarks || "",
    unitOfConsumption: data?.unitOfConsumption,
    reasonForDeviation: data?.reasonForDeviation || "",
    documents: data?.documents || [],
    rating: data?.equipment?.ratedConsumption || "",
    editRemarkReason: data?.editRemarkReason || "",
  };
  const [formData, setFormData] = useState(initialState);
  const [formData2, setFormData2] = useState(initialState);

  const [uploadedFiles, setUploadedFiles] = useState([]);
  const [uploadProgress, setUploadProgress] = useState({});
  const [equipmentOptions, setEquipmentOptions] = useState([]);
  const [editDialog, setEditDialog] = useState(false);

  useEffect(() => {
    if (id && data) {
      const selectedEquipmentId = data?.equipment?._id || "";

      setFormData({
        ...initialState,
      });
      setFormData2({
        ...initialState, // Set formData2 when the drawer is opened
      });
      setUploadedFiles(data?.documents || []); // Set uploaded files based on existing data
    } else {
      setFormData(initialState);
      setFormData2(initialState); // Reset formData2 when creating new data
      setUploadedFiles([]);
    }
  }, [data, id]);

  const handleExitAgree = () => {
    setEditDialog(false);
    setAddData(false);
    setErrors({});
    setFormData(initialState);
    setFormData2(initialState);
    setUploadedFiles(data?.documents || []);
  };

  const fetchEquipmentOptions = async () => {
    try {
      const response = await get(`/master/Heat/getEquipment`);
      setEquipmentOptions(response.data.data);
    } catch (error) {
      console.error("Error fetching equipment options:", error);
    }
  };

  // Fetch options on component mount
  useEffect(() => {
    fetchEquipmentOptions();
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setErrors((prevErrors) => ({ ...prevErrors, [name]: undefined }));

    if (name === "equipment") {
      const selectedEquipment = equipmentOptions.find(
        (item) => item._id === value
      );

      if (selectedEquipment) {
        const newRating = selectedEquipment.ratedConsumption || "";
        setFormData((prevState) => ({
          ...prevState,
          equipment: value,
          brand: selectedEquipment.brand || "",
          model: selectedEquipment.model || "",
          rating: newRating,
          unitOfConsumption: prevState.usedHours
            ? prevState.usedHours * newRating
            : "",
        }));
      }
    } else if (name === "usedHours") {
      const isValidPercentage = /^-?\d*(\.\d+)?$/.test(Number(value));
      const newUsedHours = isValidPercentage ? value : 0;
      // const newUsedHours = Number(value) || 0;

      const currentRating = formData?.rating || 0;
      setFormData((prevState) => ({
        ...prevState,
        usedHours: newUsedHours,
        unitOfConsumption: currentRating ? newUsedHours * currentRating : "",
      }));
    } else {
      setFormData((prevState) => ({ ...prevState, [name]: value }));
    }
  };

  // const handleClose = () => {
  //   setAddData(false);
  //   setErrors({});
  //   // setFormData(initialState); // Reset form data to initial state
  //   // setUploadedFiles([]); // Reset uploaded files
  // };

  const handleClose = () => {
    const isFormDataUnchanged =
      JSON.stringify(formData) === JSON.stringify(formData2);
    const isFilesUnchanged =
      JSON.stringify(uploadedFiles) ===
      JSON.stringify(formData2?.documents || []);

    if (isFormDataUnchanged && isFilesUnchanged) {
      handleExitAgree(); // Close the dialog if there are no unsaved changes
    } else {
      setEditDialog(true); // Show confirmation dialog if there are unsaved changes
    }
  };

  const validateForm = () => {
    const newErrors = {};
    inputData.forEach((input) => {
      const value = formData[input.fieldName];
      const month = formData?.consumptionPeriod?.month;
      const year = formData?.consumptionPeriod?.year;
      if (input.fieldName === "consumptionPeriod") {
        if (month === "" || !validateNumber(month))
          newErrors["month"] = "Month is required";

        if (year === "" || !validateNumber(year))
          newErrors["year"] = "Year is required";

        return;
      }

      if (input.required && !value) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }

      // Validation for numeric inputs
      if (input.type === "number") {
        if (!validateNumber(value)) {
          newErrors[input.fieldName] = numberError;
          return; // Stop further checks for this input
        }
      }

      if (!formData.unitOfConsumption) {
        const calculatedConsumption =
          (formData.usedHours || 0) * (formData.rating || 0);
        if (calculatedConsumption > 0) {
          setFormData((prevState) => ({
            ...prevState,
            unitOfConsumption: calculatedConsumption,
          }));
        } else {
          newErrors.unitOfConsumption =
            "Unit of Consumption is autofilled please reselect the Equipmet.";
        }
      }

      // if (input.fieldName === "documents" && uploadedFiles.length === 0) {
      //   console.log(input.fieldName, uploadedFiles);
      //   newErrors[input.fieldName] = `Please upload Documents`;
      // }

      // Additional checks for required fields
      if (
        input.required &&
        input.type !== "number" &&
        (!value || value.trim() === "")
      ) {
        newErrors[input.fieldName] = `${input.title} is required.`;
      }
      if (user?.endUser && id && input.fieldName === "editRemarkReason") {
        if (
          !formData[input.fieldName] ||
          formData[input.fieldName].trim() === ""
        ) {
          newErrors[input.fieldName] = "Edit Remark Reason is required";
        }
      }
    });

    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const Save = async () => {
    if (!validateForm()) return;

    // Prepare data to send, including only fields with values
    const dataToSend = {
      ...formData,
      documents: uploadedFiles,
    };

    // Conditionally delete fields if typeOfEntry is not "Individual"
    if (formData.typeOfEntry !== "Individual") {
      delete dataToSend.hours;
      delete dataToSend.industrialEquipment;
    }
    if (user?.endUser && id) {
      dataToSend.requestStatus = "edit";
      dataToSend.requestMode = true;
      dataToSend.approvalStatus = "Pending";
    }

    // Remove fields that have empty values
    // Object.keys(dataToSend).forEach((key) => {
    //   if (
    //     // dataToSend[key] === "" || // Empty strings
    //     typeof dataToSend[key] === "object" &&
    //     Object.keys(dataToSend[key]).length === 0 // Empty objects
    //   ) {
    //     delete dataToSend[key];
    //   }
    // });

    try {
      const url = id
        ? `${updateUrl}?Id=${id}` // Append the Id parameter for PUT request
        : addUrl; // Use addUrl for POST request

      const response = await (id
        ? put(url, dataToSend) // Use updated URL with Id parameter
        : post(url, dataToSend)); // For POST, no Id needed

      // Handle success
      setsnackOpen({
        open: true,
        message: response.data.message,
        severity: "success",
      });
      fetchData();
      // setFormData(initialState);
      setFormData2({ ...formData });
      // setUploadedFiles([]);
      setUploadedFiles(formData.documents || []);
      // handleClose();
      handleExitAgree();
    } catch (err) {
      console.error("Error occurred:", err);
      if (err.response && err.response.data && err.response.data.errors) {
        const errorMessages = err.response.data.errors
          .map((error) => error.msg)
          .join(", ");
        setsnackOpen({
          open: true,
          message: errorMessages,
          severity: "error",
        });
      } else if (err.response && err.response.data) {
        setsnackOpen({
          open: true,
          message: err.response.data.message,
          severity: "error",
        });
      } else {
        setsnackOpen({
          open: true,
          message: "An unknown error occurred.",
          severity: "error",
        });
      }
    }
  };

  const renderInputField = (el) => {
    if (el.options || el.type === "select") {
      return (
        <SelectField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          value={formData[el.fieldName]}
          handleChange={handleChange}
          options={el.options}
          errors={errors[el.fieldName]}
          url={el.url}
          field={el.field}
        />
      );
    }

    if (el.fieldName === "consumptionPeriod") {
      return (
        <Box sx={{ mt: 2 }}>
          <MonthYearPicker
            title={"Consumption Month"}
            {...{
              setFormData,
              setFormData2,
              formData,
              errors,
              setErrors,
            }}
          />
        </Box>
      );
    }

    if (el.type === "file") {
      return (
        <FileField
          title={formatTitleWithOptional(el.title)}
          name={el.fieldName}
          errors={errors[el.fieldName]}
          fileUrls={uploadedFiles}
          progress={uploadProgress[el.fieldName] || []}
          {...{ setUploadedFiles, setUploadProgress, setErrors }}
          // onDelete={handleDeleteFile}
        />
      );
    }

    if (el.fieldName === "remarks" || el.fieldName === "reasonForDeviation")
      return (
        <Multiline
          title={formatTitleWithOptional(el.title)}
          handleChange={handleChange}
          placeholder={el.placeholder}
          value={formData[el.fieldName] || ""}
          errors={errors[el.fieldName]}
          fieldName={el.fieldName}
        />
      );

    if (el.fieldName === "editRemarkReason") {
      if (user?.endUser && id) {
        return (
          <Multiline
            title={formatTitleWithOptional(el.title)}
            handleChange={handleChange}
            placeholder={el.placeholder}
            value={formData[el.fieldName] || ""}
            errors={errors[el.fieldName]}
            fieldName={el.fieldName}
            required={true}
          />
        );
      }
      return null; // Don't render for other cases
    }
    const shouldDisable =
      el.fieldName === "brand" ||
      el.fieldName === "model" ||
      el.fieldName === "unitOfConsumption";
    return (
      <InputField
        title={formatTitleWithOptional(el.title)}
        handleChange={handleChange}
        placeholder={el.placeholder}
        value={
          el.fieldName === "quantityConsumed"
            ? formData[el.fieldName]?.value
            : formData[el.fieldName] || ""
        }
        errors={errors[el.fieldName]}
        fieldName={el.fieldName}
        adornmentText={el.adornmentText || ""}
        disabled={shouldDisable}
      />
    );
  };

  const list = () => (
    <Box display="flex" gap={3} sx={{ width: "26rem", maxWidth: "100%" }}>
      <Box
        sx={{
          backgroundColor: "#fff",
          height: "20px",
          padding: "13px",
          margin: "30px 0 0 0",
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          borderRadius: "80%",
          width: "5%",
        }}
      >
        <IconButton onClick={handleClose} sx={{ color: "black" }}>
          <CloseIcon sx={{ fontSize: "1.2rem" }} />
        </IconButton>
      </Box>
      <Box sx={{ width: "88%", p: 3, backgroundColor: "#fff" }}>
        <Typography
          variant="h6"
          sx={{ textDecoration: "underline", fontWeight: "bold", mb: 2 }}
        >
          {id ? `Edit ${title}` : `Add ${title}`}
        </Typography>
        {inputData.map((el) => {
          // Conditional rendering for hours and industrial equipment
          if (
            (el.fieldName === "hours" ||
              el.fieldName === "industrialEquipment") &&
            formData.typeOfEntry !== "Individual"
          ) {
            return null; // Skip rendering these fields if typeOfEntry is not "Individual"
          }

          return <div key={el.fieldName}>{renderInputField(el)}</div>;
        })}
        <Box sx={{ display: "flex", justifyContent: "space-between" }}>
          <Button
            variant="contained"
            sx={{
              backgroundColor: "#0a3f73",
              textTransform: "none",
              marginTop: "10%",
            }}
            onClick={Save}
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Box>
  );

  return (
    <Drawer
      sx={{
        backgroundColor: "transparent",
        "& .MuiDrawer-paper": {
          backgroundColor: "transparent",
          boxShadow: "none",
          height: "100vh",
          minHeight: "100vh",
          overflowY: "auto",
          overflowX: "hidden",
          display: "flex",
          flexDirection: "column",
        },
      }}
      anchor="right"
      open={addData}
      onClose={handleClose}
    >
      {editDialog && (
        <EditDialog {...{ editDialog, setEditDialog, handleExitAgree }} />
      )}
      {list()}
    </Drawer>
  );
}

export default AddConsumptionEquipment;
